/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./fixedplugin.component";
var styles_FixedPluginComponent = [];
var RenderType_FixedPluginComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_FixedPluginComponent, data: {} });
export { RenderType_FixedPluginComponent as RenderType_FixedPluginComponent };
export function View_FixedPluginComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["class", "fixed-plugin"]], null, null, null, null, null))], null, null); }
export function View_FixedPluginComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "fixedplugin-cmp", [], null, null, null, View_FixedPluginComponent_0, RenderType_FixedPluginComponent)), i0.ɵdid(1, 114688, null, 0, i1.FixedPluginComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var FixedPluginComponentNgFactory = i0.ɵccf("fixedplugin-cmp", i1.FixedPluginComponent, View_FixedPluginComponent_Host_0, {}, {}, []);
export { FixedPluginComponentNgFactory as FixedPluginComponentNgFactory };
